module.exports = __webpack_public_path__ + "img/no-address.002fd895.svg";